import { render, staticRenderFns } from "./deptDesc.vue?vue&type=template&id=4f0a44b0&scoped=true&"
import script from "./deptDesc.vue?vue&type=script&lang=js&"
export * from "./deptDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a44b0",
  null
  
)

export default component.exports